<template>
  <div v-if="loading" class="loading">
    <img src="/static/images/loading.gif">
  </div>
</template>

<script>
export default {
  props: {
    loading: {},
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Loading.vue